// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WzZnt","title":"styles_title__1wsaJ"};